import { Container, Paper, Stack } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

import { Comment } from '../../../../models/Comment';
import PollCommentMenu from './PollCommentMenu/PollCommentMenu';

import './PollComment.scss';

interface PollCommentProps {
    comment: Comment;
    comments: Comment[];
    setComments: React.Dispatch<React.SetStateAction<Comment[]>>;
}

const PollComment = (props: PollCommentProps): JSX.Element => {
    const comm = props.comment;

    return (
        <Container className='poll-comment-container'>
            <Stack direction='row'>
                <Container className='comment-avatar-container'>
                    <PersonIcon />
                </Container>
                <Paper variant='outlined'>{comm.text}</Paper>
                <PollCommentMenu
                    comment={props.comment}
                    comments={props.comments}
                    setComments={props.setComments}
                />
            </Stack>
        </Container>
    );
};

export default PollComment;
